export const ROLE_IN_USE_TITLE = "Não é possível excluir o perfil";
export const ROLE_IN_USE_DESCRIPTION = "Existem usuários vinculados a este perfil.";
export const ROLE_IN_USE_GUIDANCE =
  "Para excluir este perfil, remova os usuários vinculados ou altere o perfil deles na aba Usuários.";
export const LINKED_USERS_TITLE = "Usuários vinculados";
export const LINKED_USERS_ACTION = "Ir para a aba Usuários";

export function linkedUsersLabel(count: number): string {
  return count === 1 ? "usuário vinculado a este perfil" : "usuários vinculados a este perfil";
}
